/* Includes js theme Invima */

import './components/body';
import './components/form';
import './components/validations_fields';
